<template>
  <b-form-group
    label="Telefon"
    label-for="donor_phone"
  >
    <b-form-input
      id="donor_phone"
      v-model="dataItem.donor_phone"
      placeholder="Telefon"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'DonorPhone',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
